import React, { useState } from 'react';
import { useDrag } from 'react-dnd';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    hideOnDrag?: boolean;
    items?: any;
    type?: string;
    name?: string;
    onClick?: any;
    isLogicMaker?: boolean;
}

export interface DragType extends React.HTMLAttributes<HTMLDivElement> {
    setHide: React.Dispatch<React.SetStateAction<boolean>>;
    items?: any;
    type?: string;
}

export const DragBox = ({ items, children, hideOnDrag = false,type,name,onClick,isLogicMaker,...rest }: Props) => {
    const [hide, setHide] = useState(false);

    const [{ isDragging }, drag] = useDrag(() => ({
        type: type || 'drag-box',
        item: { children, setHide, items,name ,...rest } as DragType,
        collect: monitor => ({
            isDragging: monitor.isDragging()
        })
    }));

    const renderDropped = () => {
        return <div ref={drag} />;
    };

    const renderDragBox = () => {
        return (
            <div onClick={onClick} ref={drag} {...rest}>
                {children}
            </div>
        );
    };
    return  isLogicMaker? renderDragBox() : (isDragging && hideOnDrag) || hide  ? renderDropped() : renderDragBox();
};
